import { DualHopperAnimatic, type DualHopperAnimaticProps } from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_METRIC_1_LABEL_EXACT,
  ANIMATIC_PRIMARY_LABEL_EXACT,
} from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { type AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticDualHopper = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const hopper = config.specificAnimaticConfig?.dualHopper;
  const leftValue = hopper?.leftLevel
    ? convertPercentToDecimal(getRefValue(hopper.leftLevel))
    : undefined;
  const rightValue = hopper?.rightLevel
    ? convertPercentToDecimal(getRefValue(hopper.rightLevel))
    : undefined;
  return (
    <ScaledAnimatic data-component="AnimaticDualHopper" className={className} scaleX={1} scaleY={1}>
      <DualHopperAnimatic
        leftValue={leftValue}
        rightValue={rightValue}
        leftVariant={hopper?.leftVariant as DualHopperAnimaticProps['leftVariant']}
        rightVariant={hopper?.rightVariant as DualHopperAnimaticProps['rightVariant']}
        primaryLabel={getLabel(labels, ANIMATIC_PRIMARY_LABEL_EXACT)?.text}
        metric1Label={getLabel(labels, ANIMATIC_METRIC_1_LABEL_EXACT)?.text}
        state={state}
      />
    </ScaledAnimatic>
  );
};
